import React, { useEffect } from 'react';
import { Button, Card } from 'antd';
import { dateFormat } from '../utils';
import cardBack from '../assets/magic_card_back.jpg';

function getCardImage(card,face) {
    if (card && card.image_uris && card.image_uris.normal !== "") {
        return card.image_uris.normal;
    }
    if (card && card.card_faces && card.card_faces.length > 0) {
        // If the card has front/back(idx 0/1) faces, return the face's normal image
        return card.card_faces[face].image_uris.normal;
    }
    return cardBack;
}

function ShowCard(props) {
    const [flip, setFlip] = React.useState(0);

    useEffect(() => {
        // Reset flip state when props.item changes
        setFlip(0);
    }, [props.item]);

    // console.warn('ShowCard props: ', props);
    if (props.item === null || props.item === undefined ) {
        return <Card className="mtg-card" cover={<img alt="No card selected" src={cardBack} />} />;
    }
    if (props.item.card_faces && props.item.card_faces.length > 0) {
        // If the card has front/back faces, use the flip state to determine which face to show
        return (
            <Card
                className="mtg-card"
                cover={<div>
                    <img style={{ width: '100%', height: 'auto' }} alt={props.item.name} src={getCardImage(props.item, flip)} />
                    <div>
                        <Button type="primary" onClick={() => setFlip(flip === 0 ? 1 : 0)}>
                            Flip Card
                        </Button>
                    </div>
                </div>}>
                <Card.Meta title={props.item.name} description={dateFormat(props.item.date)} />
            </Card>
        );
    }
    return (
        <Card
            className="mtg-card"
            cover={<div><img style={{ width: '100%', height: 'auto' }} alt={props.item.name} src={getCardImage(props.item,flip)}/></div>}>
            <Card.Meta title={props.item.name} description={dateFormat(props.item.date)} />
        </Card>
    );
}

export default ShowCard;